import React from 'react'

export default React.lazy(() => import('./ISO14064ReportManagement'))
